import { render, staticRenderFns } from "./marketing.vue?vue&type=template&id=55e92452&"
import script from "./marketing.vue?vue&type=script&lang=js&"
export * from "./marketing.vue?vue&type=script&lang=js&"
import style0 from "./marketing.vue?vue&type=style&index=0&id=55e92452&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CookieConsent: require('/var/www/jaty-frontend/components/CookieConsent.vue').default,HomeHeader: require('/var/www/jaty-frontend/components/HomeHeader.vue').default,MarketingSubnav: require('/var/www/jaty-frontend/components/marketing/Subnav.vue').default,HomeFooter: require('/var/www/jaty-frontend/components/HomeFooter.vue').default})
